<div *ngIf="hasData()">
  <ng-container>
    <div *ngFor="let note of datasource.rows">
      <app-card-item [note]="note">
      </app-card-item>
    </div>
  </ng-container>
</div>
<div class="empty-state-container" *ngIf="!hasData()">
  <!--XTODO -->
  <img class="empty-state-image" src="{{ 'EmptyState.svg' | xsImage }}">
  <div class="empty-state-caption-top">{{ 'No_Data_Keyword' | saI18n }}</div>
</div>

